import { merge } from '../../helper';
import isEmptyArray from '../../general/isEmpty/isEmptyArray';

import * as exTable from '../table';

import * as exOperation from './operation';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const build: Record<string, any> = {
        elements: {},
    };

    // Create element (table)
    const table = exTable.create({
        merge: {
            ...defConfig,
            data: null,
        },
        class: {
            new: 'table datatable',
        },
    });
    build.element = table.element;
    build.elements = table.elements;

    // ------------------------------------------------------------------------

    // Settings
    settings(build, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return build;
}

function settings(build: Record<string, any>, config: Record<string, any> = {}): void {
    const elements = build.elements;

    // ------------------------------------------------------------------------

    // If using data
    if (!isEmptyArray(config.data)) {
        data(elements.element, config);
    }
}

// ----------------------------------------------------------------------------

function data(element: HTMLTableElement, config: Record<string, any> = {}): void {
    exOperation.start(element, config);
}

// ----------------------------------------------------------------------------

export { create, data };
